import { useEffect } from 'react'
import { getTelegramWebApp, isTelegram } from '@/config/telegram'

export const useTelegram = () => {
  const webApp = getTelegramWebApp()

  useEffect(() => {
    if (webApp) {
      webApp.ready()
      webApp.expand()
    }
  }, [webApp])

  return {
    isTelegram: isTelegram(),
    webApp,
    initData: webApp?.initData,
    user: webApp?.initDataUnsafe?.user,
    themeParams: webApp?.themeParams,
    colorScheme: webApp?.colorScheme,
  }
}
